import { DELETE_SAMPLE_BY_REF } from "../constants";
import { getLocalStorage } from "../utils";

export interface DeleteSampleByRefRequest {
  docReference: string;
}

export const deleteSampleByRef = async (deleteRequest: DeleteSampleByRefRequest): Promise<any> => {
  try {
    const deleteSampleResponse = await fetch(DELETE_SAMPLE_BY_REF, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getLocalStorage("id-token")}`,
      },
      body: JSON.stringify(deleteRequest),
    });
    const deleteResponseContent = await deleteSampleResponse.json();

    return deleteResponseContent.data.message === "Success";
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("error", error);
  }

  return false;
};
